export type Section =
  | 'about'
  | 'home'
  | 'favourites'
  | 'shop'
  | 'gallery'
  | 'posts'
  | 'stats';

export interface SectionsState {
  active: Section;
  isLoading: boolean;
  streamId?: string;
}

export enum SectionViewType {
  LIST = 'list',
  GRID = 'grid',
}
